// src/lib/ticketFormat.js
//
// Formatting shared by printed ticket documents. en-US throughout, to match
// the M/D/YYYY and 12-hour clock the shop's existing forms use — en-CA
// renders these as 2026-07-31 and 16:30, which reads wrong against paper.
//
// PrintTicket.jsx keeps its own copies of these (this file only backs the
// superticket) so the existing landscape ticket stays byte-for-byte as it
// was before the superticket was added.

import { fmtTime } from './priority';

export const fmt = (n) => '$' + (Number(n) || 0).toFixed(2);

export const TYPE_TITLE = {
  carry_out: 'Carry Out', local_delivery: 'Local Delivery',
  pick_up: 'Pick Up', wire_out: 'Wire Out', wire_in: 'Wire In',
};

/** "7/31/2026 4:30 PM - Friday", with the time when one was given. */
export function fmtNeededDate(dateStr, timeStr) {
  if (!dateStr) return '—';
  const d = new Date(dateStr + 'T12:00:00');   // noon: timezone can't flip the day
  const date = d.toLocaleDateString('en-US', { month: 'numeric', day: 'numeric', year: 'numeric' });
  const day  = d.toLocaleDateString('en-US', { weekday: 'long' });
  return `${date}${timeStr ? ` ${fmtTime(timeStr)}` : ''} - ${day}`;
}

export function fmtTaken(ts) {
  if (!ts) return '—';
  const d = ts.toDate ? ts.toDate() : new Date(ts);
  return d.toLocaleString('en-US', {
    month: 'numeric', day: 'numeric', year: 'numeric',
    hour: 'numeric', minute: '2-digit',
  });
}

export const STATUS_WORD = {
  pending: 'Pending', draft: 'Draft', ready: 'Ready',
  completed: 'Completed', paid: 'Paid', void: 'CANCELLED',
};
export const DESIGN_WORD = {
  not_started: 'Not made', in_progress: 'In progress', done: 'Made',
};
